module.exports = __webpack_public_path__ + "static/media/Large_2014.635290af.svg";